import type { Routes } from '@atlassian/react-resource-router/src/common/types';
import { getSpaRoutes } from './getSpaRoutes.tsx';

// Yes, this is a kind of re-export, yes they're bad - however we need a separate asset to act as a "jump asset"
// to allow us to apply the `unstable_forceSkipWrappedAssets` optimisation to the route map. If it was the entry
// point of the bundle this wouldn't work, we still need a wrapped entry point.
const getSpaRoutesAsync = (): Routes => getSpaRoutes();

export default getSpaRoutesAsync;
